import React, { useEffect, useState } from "react";
import { useUser } from "../context/UserContext";
import { getLibraryQueue, subscribeLibrarySync } from "../utils/librarySync";
import { fetchWithAuth } from "../services/api";
export default function LibrarySyncStatus() {
  const { user } = useUser(),
    [state, setState] = useState({ pending: 0, errors: [] }),
    [error, setError] = useState("");
  useEffect(() => {
    let active = true;
    let q = getLibraryQueue(fetchWithAuth);
    const update = () => {
      q = getLibraryQueue(fetchWithAuth);
      if (active) setState(q?.getState() || { pending: 0, errors: [] });
    };
    const retry = () => {
      if (document.visibilityState === "hidden") return;
      q = getLibraryQueue(fetchWithAuth);
      void q
        ?.flush()
        .then(() => active && setError(""))
        .catch((e) => active && setError(e.message));
    };
    const unsubscribe = subscribeLibrarySync(update);
    void q?.ready
      .then(() => {
        update();
        retry();
      })
      .catch((e) => active && setError(e.message));
    const timer = setInterval(retry, 15000);
    window.addEventListener("online", retry);
    document.addEventListener("visibilitychange", retry);
    return () => {
      active = false;
      unsubscribe();
      clearInterval(timer);
      window.removeEventListener("online", retry);
      document.removeEventListener("visibilitychange", retry);
    };
  }, [user?.id]);
  if (!user || (!state.pending && !error)) return null;
  const q = getLibraryQueue(fetchWithAuth);
  return (
    <aside
      role="status"
      style={{
        position: "fixed",
        bottom: 80,
        left: 12,
        right: 12,
        margin: "0 auto",
        maxWidth: 600,
        padding: 12,
        borderRadius: 12,
        background: "#232629",
        color: "#fff",
        zIndex: 10001,
        boxShadow: "0 4px 20px #0005",
      }}
    >
      <div>
        Ожидают синхронизации: {state.pending}. Изменения сохранены на этом
        устройстве.
      </div>
      {state.authRequired && (
        <p>
          Для синхронизации войдите в аккаунт снова.{" "}
          <a href="/login" style={{ color: "inherit" }}>
            Войти
          </a>
        </p>
      )}
      {state.errors.slice(0, 2).map((item) => (
        <div key={item.id}>
          <strong>{item.title}</strong>: {item.message}{" "}
          <button
            onClick={() =>
              void q.discard(item.id).catch((e) => setError(e.message))
            }
          >
            Оставить серверную версию
          </button>
        </div>
      ))}
      {error && <p role="alert">{error}</p>}
      <button
        onClick={() =>
          void q
            .flush()
            .then(() => setError(""))
            .catch((e) => setError(e.message))
        }
      >
        Повторить синхронизацию
      </button>
    </aside>
  );
}
